import { Component, EventEmitter, input, Input, OnInit, Output, TemplateRef, computed, signal, effect } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { TaskService } from '../../../../services/task.service';
import SeoWorkTaskType = Boo.Objects.Work.SeoMinute.SeoWorkTaskType;
import WorkRequestDetail = Boo.Objects.Work.SeoMinute.WorkRequestDetail;

@Component({
  selector: 'app-components-managecustomer-past-work',
  templateUrl: './past-work.component.html'
})
export class PastWorkComponent implements OnInit {
  pastWorkRequestDetails = input<WorkRequestDetail[]>();
  @Input() hasValidAccessDetails: boolean;
  @Input() customer: Boo.Objects.Customer;
  @Output() editWorkRequest = new EventEmitter<WorkRequestDetail>();
  @Output() deleteWorkRequest = new EventEmitter<WorkRequestDetail>();

  pendingTasks = signal<Boo.Objects.PendingTaskDetail[]>([]);

  work = computed<WorkRequestWithTaskInsertedDate[]>(() => {
    return this.pastWorkRequestDetails().map(x => { return { ...x, TaskInsertedDate: this.pendingTasks().find(y => y.TaskId === x.OrderTaskId)?.InsertedDate ?? new Date() }; });
  });

  isLoading = false;

  constructor(private modalService: NgbModal, private taskService: TaskService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.taskService.getPendingWorkForCustomer(this.customer.CustomerId)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (pendingTasks: Boo.Objects.PendingTaskDetail[]) => this.pendingTasks.set(pendingTasks),
        error: err => toastr.error(err.message)
      });
  }

  deleteItem(content: TemplateRef<any>, item: WorkRequestDetail): void {
    this.modalService.open(content).result
      .then(() => {
        this.isLoading = true;
        this.deleteWorkRequest.emit(item);
      });
  }
}

interface WorkRequestWithTaskInsertedDate extends WorkRequestDetail {
  TaskInsertedDate: Date
}